<template>
  <tr>
    <td>{{ theCity.name }}</td>
    <td>
      <button class="purple-btn ml-2" @click="edit">ویرایش</button
      ><button class="purple-btn" @click="remove">حذف</button>
    </td>
  </tr>
</template>
<script>
export default {
  props: ["theCity"],
  methods: {
    edit: function () {
      this.$router.push("/admin/edit/district/" + this.theCity.id);
    },
    remove: function () {
      this.$emit("deleteMe", this.theCity.id);
    },
  },
};
</script>
<style scoped>
td {
  border: 1px solid rgb(218, 218, 218);
  text-align: center;
  padding: 5px;
}
</style>
